import React from "react";
import ResultFormPage from "../components/results/ResultFormPage";

const ResultEdit = () => <ResultFormPage mode="edit" />;

export default ResultEdit;
